import { CONFIG } from '@hero/core';
import type { VehicleBrand, VehicleTypes } from '@hero/schema';
import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

/**
 * Translated vehicle brand label from `m-vehicle:brands.*`.
 * Returns `brands.not_known` when brand is missing (optional on Vehicle).
 */
export function getVehicleBrandLabel(
  brand: VehicleBrand | undefined | null,
  t: TFunction,
): string {
  if (!brand) {
    return t('brands.not_known');
  }
  return t(`brands.${brand}`, { defaultValue: brand });
}

export const useVehicleOptions = () => {
  const { t } = useTranslation('m-vehicle');
  const allVehicles = CONFIG.vehicles.types;
  const groupedVehicles = CONFIG.vehicles.groupedTypes;

  const getVehicleSpec = (vehicleType: VehicleTypes) => {
    return CONFIG.vehicles.types.find(vehicle => vehicle.id === vehicleType);
  };

  /**
   * Get translated vehicle display name
   * Uses i18n key: m-vehicle:types.{vehicle}
   * Falls back to raw vehicle type if translation not found
   */
  const getVehicleDisplayName = (vehicle: VehicleTypes) => {
    return t(`types.${vehicle}` as never);
  };

  return {
    allVehicles,
    groupedVehicles,
    getVehicleSpec,
    getVehicleDisplayName,
    getVehicleBrandLabel: (brand: VehicleBrand | undefined | null) =>
      getVehicleBrandLabel(brand, t),
  };
};
